import { useEffect, useState } from 'react';
import range from 'lodash/range';
import useNoundlesTheory from './useNoundlesTheory';

import tokenData from '../data/theory.json';

// TODO: store in context
const useNoundlesTheoryTokenDetails = () => {
  const noundlesTheory = useNoundlesTheory();
  const [tokens, setTokens] = useState({});

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_CHAIN_ID === '1') {
      setTokens(Object.assign({}, tokenData));
    } else {
      setTokens({});
      if (noundlesTheory) {
        const fetchTokenData = async (tokenId) => {
          const type = await noundlesTheory.noundleType(tokenId);
          const offset = await noundlesTheory
            .noundleOffsetCount(tokenId)
            .then((n) => n.toNumber());

          return { type, offset };
        };

        const fetchTokens = async () => {
          const totalSupply = await noundlesTheory
            .totalSupply()
            .then((n) => n.toNumber());

          const batchSize = 100;
          for (let batchId = 0; batchId * batchSize < totalSupply; batchId++) {
            const batchStart = batchId * batchSize;
            const batchEnd = Math.min(batchStart + batchSize, totalSupply);
            const batch = await Promise.all(
              range(batchStart, batchEnd).map((tokenId) =>
                fetchTokenData(tokenId).then((tokenData) => [
                  tokenId,
                  tokenData,
                ])
              )
            );
            setTokens((tokens) => ({
              ...tokens,
              ...Object.fromEntries(batch),
            }));
          }
        };
        fetchTokens();
      }
    }
  }, [noundlesTheory]);

  return tokens;
};

export default useNoundlesTheoryTokenDetails;
